import React from 'react'
import cx from 'classnames'
import SpinGif from './SpinGif.webp'

import type { SpinnerProps } from './types'

const Spinner = ({ className = '' }: SpinnerProps) => {
  const classNames = cx('spinner-ts', { [className]: !!className })
  return (
    <div className={classNames}>
      <img src={SpinGif} alt="loading" />
    </div>
  )
}

export default Spinner
